"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductLists = void 0;
var _createOrGetFavoriteProductList = require("./createOrGetFavoriteProductList");
var _getPersonalProductLists = require("./getPersonalProductLists");
/* istanbul ignore file -- api */

const getProductLists = async ({
  arePersonalListsEnabled,
  client,
  customerId,
  isAnonymousUser
}) => {
  if (isAnonymousUser) {
    return {
      favoriteProductList: null,
      personalProductLists: [],
      maximumAllowedPersonalLists: 0
    };
  }
  const [favoriteProductList, {
    lists,
    maximumAllowedPersonalLists
  }] = await Promise.all([(0, _createOrGetFavoriteProductList.createOrGetFavoriteProductList)({
    client,
    customerId
  }), arePersonalListsEnabled ? (0, _getPersonalProductLists.getPersonalProductLists)({
    client,
    customerId
  }) : Promise.resolve({
    lists: [],
    maximumAllowedPersonalLists: 0
  })]);
  return {
    favoriteProductList,
    personalProductLists: lists,
    maximumAllowedPersonalLists
  };
};
exports.getProductLists = getProductLists;
//# sourceMappingURL=getProductLists.js.map